module.exports = __webpack_public_path__ + "static/img/female-bg-en.5604ca3f.png";